module.exports = __webpack_public_path__ + "img/newsImg11-36.e7fc2d1f.png";